import type { FormConfig, PropertySchema, ServicesShapesContext } from '@takeshape/schema';
import { getDateTableCell } from '../common/components/table/index.js';
import type { TableColumn } from '../common/components/table/types.js';
import { isImageSchema } from '../schema/util/is-image-schema.js';
import DateHeaderCell from './components/date-header-cell/date-header-cell.js';
import EnabledIndicatorCell from './components/enabled-indicator-cell.js';
import EnabledIndicatorHeaderCell from './components/enabled-indicator-header-cell.js';
import MemberCell from './components/member-cell/index.js';
import StatusIndicatorCell from './components/status-indicator-cell/index.js';
import ThumbnailCell from './components/thumbnail-cell.js';
import ThumbnailHeaderCell from './components/thumbnail-header-cell.js';

export function getOrder(schema: PropertySchema, config?: FormConfig): string[] {
  return config?.order || (schema.properties ? Object.keys(schema.properties) : []);
}

export function getStringProps(schema: PropertySchema, order: string[], limit?: number): string[] {
  const props = schema.properties;
  const result: string[] = [];

  if (props) {
    for (const name of order) {
      const prop = props[name];
      if (prop?.type === 'string' && prop?.format !== 'date-time') {
        result.push(name);
      }

      if (limit !== undefined && result.length === limit) {
        break;
      }
    }
  }

  return result;
}

export function getFirstImageProp(
  context: ServicesShapesContext,
  schema: PropertySchema,
  order: string[]
): string | undefined {
  return order.find((name) => isImageSchema(context, schema.properties?.[name]));
}

export function getTableCellConfig(
  context: ServicesShapesContext,
  columnName: string,
  schema: PropertySchema
): TableColumn {
  const cellConfig: TableColumn = {
    title: schema.title,
    name: columnName
  };
  switch (schema.type) {
    case 'boolean':
      cellConfig.component = EnabledIndicatorCell;
      if (columnName === '_enabled') {
        cellConfig.title = ' ';
        cellConfig.headerComponent = EnabledIndicatorHeaderCell;
      }

      break;
    case 'string':
      if (columnName === '_status') {
        cellConfig.component = StatusIndicatorCell;
        cellConfig.title = ' ';
        cellConfig.headerComponent = EnabledIndicatorHeaderCell;
      }

      if (schema.format === 'date-time') {
        cellConfig.component = getDateTableCell('MM/dd/yyyy, h:mm a');
        cellConfig.headerComponent = DateHeaderCell;
      }

      break;
    default:
      if (columnName === '_createdBy' || columnName === '_updatedBy') {
        cellConfig.headerComponent = EnabledIndicatorHeaderCell;
        cellConfig.component = MemberCell;
      } else if (isImageSchema(context, schema)) {
        cellConfig.component = ThumbnailCell;
        cellConfig.headerComponent = ThumbnailHeaderCell;
      }
  }

  return cellConfig;
}
